var exports = {
  "M": "xa15a2ab7--fa069a--top",
};

module.exports = exports;
